export const metaAdapter = (data) => {
  return {
    total: data.total,
  };
};
